const ROLE_COLORS = {
  ROOT: "bg-zinc-950 text-white",
  ADMIN: "bg-red-600 text-white",
  SUPERVISOR: "bg-orange-400 text-black",
  EDITOR: "bg-blue-600 text-white",
  READER: "bg-gray-500 text-white",
};

const UserRoleChip = ({ role, title }) => (
  <span
    title={title}
    className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold leading-none ${
      ROLE_COLORS[role] || "bg-zinc-500 text-white"
    }`}
  >
    {role}
  </span>
);

export default UserRoleChip;
